import React from 'react'
import { observer } from 'mobx-react'
import c from 'classnames'
import { Link } from 'react-router-dom'

const TopBar = ({ topBarStore }) => {
  const {
    actionIcon,
    title,
    navigation,
    logoUrl,
    authAction,
		hideLogo
  } = topBarStore

  return (
	<div className="h-14 flex items-center bg-gray-800 flex-shrink-0 relative">
	  {actionIcon && (
		<div
		  className="flex items-center justify-center w-8 mr-4 absolute top-1/2 transform -translate-y-1/2 left-4 text-white"
		>
		  {actionIcon}
		</div>
	  )}
	  <div className={c(
		  'mx-8 flex flex-1 justify-center text-center md:justify-start',
		  title && 'hidden sm:block',
		  actionIcon && 'sm:mx-16'
	  )}>
		{!hideLogo && <Link to={logoUrl} className="flex">
		  <img src="/icons/bootvision-logo-white.svg" alt="BootVision" />
		</Link>}
	  </div>
	  {navigation && <div className="mr-12 relative z-10 md:hidden">{navigation}</div>}
	  {title && (
	  	<div className="mx-8 flex flex-1 justify-center text-center font-bold text-white sm:absolute sm:left-1/2 sm:transform sm:-translate-x-1/2 sm:mx-0">
		  {title}
	  	</div>
	  )}
	  {authAction && <div className="z-50 absolute top-1/2 right-4 transform -translate-y-1/2">{authAction}</div>}
	</div>
  )
}

export default observer(TopBar)
